// continuous mode の発話 audio を R2 保存するための WAV encoder。
// VAD (onSpeechEnd) が渡す Float32Array (16 kHz mono PCM) を
// 44-byte RIFF header + s16le の WAV Blob に変換する。
// 旧 push-to-talk では MediaRecorder が webm/mp4 コンテナを直接吐いていたが、
// continuous 経路は生 PCM しか持たないため WAV に自前で包む。
export function encodeWavPcm16(samples: Float32Array, sampleRate = 16000): Blob {
  const numChannels = 1;
  const bytesPerSample = 2;
  const dataSize = samples.length * bytesPerSample;
  const buffer = new ArrayBuffer(44 + dataSize);
  const view = new DataView(buffer);

  const writeAscii = (offset: number, s: string) => {
    for (let i = 0; i < s.length; i += 1) {
      view.setUint8(offset + i, s.charCodeAt(i));
    }
  };

  const blockAlign = numChannels * bytesPerSample;
  const byteRate = sampleRate * blockAlign;

  // RIFF header (44 bytes)
  writeAscii(0, "RIFF");
  view.setUint32(4, 36 + dataSize, true); // RIFF chunk size
  writeAscii(8, "WAVE");
  writeAscii(12, "fmt ");
  view.setUint32(16, 16, true); // fmt chunk size (PCM)
  view.setUint16(20, 1, true); // audio format 1 = linear PCM
  view.setUint16(22, numChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, byteRate, true);
  view.setUint16(32, blockAlign, true);
  view.setUint16(34, bytesPerSample * 8, true); // bits per sample
  writeAscii(36, "data");
  view.setUint32(40, dataSize, true);

  // Float32 [-1, 1] → Int16 (clamp してから scale)
  let offset = 44;
  for (let i = 0; i < samples.length; i += 1) {
    const clamped = Math.max(-1, Math.min(1, samples[i]));
    view.setInt16(offset, clamped < 0 ? clamped * 0x8000 : clamped * 0x7fff, true);
    offset += 2;
  }
  return new Blob([buffer], { type: "audio/wav" });
}
